<header class="sub-page-layout__header facilityCode__header">
  <div class="facilityCode__header-text h2 h2--semi-bold">Facility Codes</div>
  <mat-slide-toggle
    class="facilityCode__active-toggle"
    [checked]="activeFilter === 'active'"
    color="primary"
    (change)="showInactiveChanges($event)"
  >
    <div *ngIf="activeFilter !== 'inactive'">Active</div>
    <div *ngIf="activeFilter === 'inactive'">Inactive</div>
  </mat-slide-toggle>
  <button mat-flat-button color="primary" class="facilityCode__add-item" (click)="uploadCodes()" *ngIf="!viewOnly">
    <mat-icon>file_upload</mat-icon> Upload Facility Codes
  </button>
  <button mat-flat-button color="primary" class="facilityCode__add-item" (click)="addFacilityCode()" *ngIf="!viewOnly">
    <mat-icon>add_circle_outline</mat-icon> Add Facility Code
  </button>
</header>
<div *ngIf="dataSource && gridConfig" class="lib-grid__grid-container">
  <lib-grid [dataSource]="dataSource" [gridConfiguration]="gridConfig" skipLoadOnInit="true" loadAfterInit="true">
    <div class="">
      <h4>No Facility Codes Found.</h4>
    </div>
  </lib-grid>
</div>
<footer *ngIf="isImplementation" class="facilityCode__footer">
  <lib-button-loading color="primary" class="facilityCode__button" (clickEvent)="next()" id="nextButton"
    >Next
  </lib-button-loading>
</footer>
